export const chatData = [
    {
        category: 'Dashboard & Account Management',
        keywords: ['dashboard', 'account', 'profile'],
        questions: [
            {
                q: 'How do I update my profile information?',
                a: 'You can update your profile from the sidebar. Click My Account, then select Account Information. Click Edit to update your profile details.',
                keywords: ['update', 'profile', 'information', 'edit'],
            },
            {
                q: 'How do I change my password?',
                a: 'Go to My Account → Account Information. Click Change Password. A confirmation email will be sent to you.',
                keywords: ['password', 'change', 'reset'],
            },
            {
                q: 'How can I deactivate my account temporarily?',
                a: 'To request account deactivation, please contact our support team. Account status changes are handled by administrators for security and compliance reasons.',
                escalate: true,
                keywords: ['deactivate', 'temporary', 'account'],
            },
        ],
    },
    {
        category: 'Posting & Managing Loads (Shippers & Brokers)',
        roles: ['shipper', 'broker'],
        keywords: ['post', 'load', 'manage'],
        questions: [
            {
                q: 'How do I post a new load?',
                a: 'Shippers and brokers can post loads by clicking Post Load from the sidebar or using the Post Load button at the top of the dashboard.',
                keywords: ['post', 'new load'],
            },
            {
                q: 'How can I edit an existing load?',
                a: 'Go to Post Load from the sidebar, locate the load in the list, and click the Edit option in the Actions column.',
                keywords: ['edit', 'update load'],
            },
            {
                q: 'How do I delete a posted load?',
                a: 'Navigate to Post Load, find the load in the list, and click Delete in the Actions column.',
                keywords: ['delete', 'remove load'],
            },
            {
                q: 'Why is my load not appearing in search results?',
                a: 'Loads posted by shippers or brokers are generally visible to carriers immediately. If a load is not appearing, please confirm that it is active, not expired, and matches the selected search filters. If the issue persists, contact support for assistance.',
                escalate: true,
                keywords: ['not appearing', 'search', 'load'],
            },
            {
                q: 'Can I repost an expired load?',
                a: 'Expired loads cannot be reposted. You may use the Repost option on active loads to create a new posting.',
                keywords: ['repost', 'expired load'],
            },
        ],
    },
    {
        category: 'Finding Loads (Carriers)',
        roles: ['carrier'],
        keywords: ['find loads', 'search'],
        questions: [
            {
                q: 'How do carriers find available loads?',
                a: 'Carriers can browse loads posted by shippers and brokers using the Search Loads section. Filters such as origin, destination, and equipment type help narrow results. Load details include contact information for direct communication.',
                keywords: ['carriers', 'find loads'],
            },
        ],
    },
    {
        category: 'Safety, Trust & Reporting',
        keywords: ['safety', 'trust', 'report'],
        questions: [
            {
                q: 'Are users verified on ShipperDock?',
                a: 'ShipperDock performs business and authority verification at the time of review. Verified users receive a badge indicating confirmed credentials. Verification does not guarantee ongoing compliance.',
                keywords: ['verified', 'verification'],
            },
            {
                q: 'How do I report suspicious activity?',
                a: 'Please report suspicious activity through this live chat. Your report will be reviewed by our support team and escalated if necessary.',
                escalate: true,
                keywords: ['report', 'suspicious'],
            },
        ],
    },
    {
        category: 'Pricing, Plans & Billing',
        keywords: ['pricing', 'billing', 'subscription'],
        questions: [
            {
                q: 'Is there a free trial available?',
                a: 'Yes. ShipperDock offers a free trial that allows users to explore platform features before starting a paid subscription.',
                keywords: ['free trial', 'trial'],
            },
            {
                q: 'Can I cancel my subscription at any time?',
                a: 'Yes. You can cancel your subscription from My Account → Billing. Access remains active until the end of the current billing period.',
                keywords: ['cancel', 'subscription'],
            },
            {
                q: 'What happens if my payment fails?',
                a: 'If a payment fails, your subscription may enter a past-due status. Please update your payment method to avoid service interruption.',
                keywords: ['payment failed', 'past due'],
            },
        ],
    },
    {
        category: 'Technical Support',
        keywords: ['technical', 'error', 'support'],
        questions: [
            {
                q: 'The website is not working properly.',
                a: 'Please try refreshing the page, checking your internet connection, clearing your browser cache, or logging out and back in. If the issue persists, a support agent will assist you.',
                keywords: ['not working', 'issue'],
            },
            {
                q: 'I’m seeing an error message.',
                a: 'If basic troubleshooting does not resolve the issue, you will be connected to a support agent for assistance.',
                escalate: true,
                keywords: ['error message'],
            },
        ],
    },
    {
        category: 'Feedback & Feature Requests',
        keywords: ['feedback', 'feature'],
        questions: [
            {
                q: 'How can I give feedback or suggest a feature?',
                a: 'You can submit feedback directly from the dashboard. All suggestions are reviewed for future improvements.',
                keywords: ['feedback', 'suggest'],
            },
        ],
    },
];
